import { useEffect, useState } from 'react';
import PropertySelector from './PropertySelector';
import LanguageSelector from './LanguageSelector';
import ChatWindow from './ChatWindow';
import SystemsPanel from './SystemsPanel';
import { DEFAULT_GUEST_CONTEXT } from './valamar-theme';
import { checkApiHealth } from './demoApi';

export default function DemoLayout() {
  const [propertyId, setPropertyId] = useState('pical-resort');
  const [language, setLanguage] = useState('en');
  const [guestContext, setGuestContext] = useState(DEFAULT_GUEST_CONTEXT);
  const [panelOpen, setPanelOpen] = useState(false);
  const [apiOk, setApiOk] = useState(null);

  useEffect(() => {
    checkApiHealth().then(setApiOk);
    const interval = setInterval(() => checkApiHealth().then(setApiOk), 15000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="demo-layout">
      <header className="demo-header">
        <div className="demo-header-brand">
          <span className="demo-header-logo">Valamar</span>
          <span className="demo-header-claim">Holiday as you are</span>
        </div>
        <div className="demo-header-spacer" />
        <div className="demo-header-actions">
          {apiOk !== null && (
            <span className={`demo-api-status ${apiOk ? 'ok' : 'err'}`}>
              API {apiOk ? 'connected' : 'offline — run wrangler dev'}
            </span>
          )}
          <PropertySelector value={propertyId} onChange={setPropertyId} />
          <LanguageSelector value={language} onChange={setLanguage} />
          <button
            type="button"
            className="demo-systems-toggle"
            onClick={() => setPanelOpen((o) => !o)}
          >
            ⚙ Systems
          </button>
        </div>
      </header>

      <div className="demo-body">
        <ChatWindow
          propertyId={propertyId}
          language={language}
          guestContext={guestContext}
        />

        <div
          className={`demo-panel-overlay ${panelOpen ? 'open' : ''}`}
          onClick={() => setPanelOpen(false)}
          role="presentation"
        />

        <aside className={`demo-panel-col ${panelOpen ? 'open' : ''}`}>
          <SystemsPanel
            guestContext={guestContext}
            onChange={setGuestContext}
          />
        </aside>
      </div>
    </div>
  );
}
